var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "tab-pane fade in active",
      attrs: { id: "tab_vendor_partnerships" }
    },
    [
      _vm.loaders.vendors || _vm.vendors.length > 0
        ? _c(
            "div",
            { staticClass: "library__group h-center-align" },
            [
              _vm.featuredVendors.length > 0
                ? [
                    _c("div", { staticClass: "library__group-header" }, [
                      _vm._v("Featured Vendors")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "library__collection library__collection--vendors"
                      },
                      [
                        _vm.loaders.vendors
                          ? _c(
                              "div",
                              { staticClass: "loading-indicator" },
                              [
                                _c("MoonLoader", {
                                  attrs: { size: "75px", color: "#ffffff" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.featuredVendors, function(vendor, index) {
                          return _c("VendorCard", {
                            key: "featured-vendor-" + index,
                            attrs: { vendor: vendor }
                          })
                        })
                      ],
                      2
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              _vm.categoriesUsed
                ? [
                    _c("div", { staticClass: "library__group-header" }, [
                      _vm._v("Audiology")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "library__collection library__collection--vendors"
                      },
                      [
                        _vm.loaders.vendors
                          ? _c(
                              "div",
                              { staticClass: "loading-indicator" },
                              [
                                _c("MoonLoader", {
                                  attrs: { size: "75px", color: "#ffffff" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.audiologyVendors, function(vendor, index) {
                          return _c("VendorCard", {
                            key: "audiology-vendor-" + index,
                            attrs: { vendor: vendor }
                          })
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "library__group-header" }, [
                      _vm._v("Allergy & Sinus")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "library__collection library__collection--vendors"
                      },
                      [
                        _vm.loaders.vendors
                          ? _c(
                              "div",
                              { staticClass: "loading-indicator" },
                              [
                                _c("MoonLoader", {
                                  attrs: { size: "75px", color: "#ffffff" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.allergyVendors, function(vendor, index) {
                          return _c("VendorCard", {
                            key: "allergy-vendor-" + index,
                            attrs: { vendor: vendor }
                          })
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "library__group-header" }, [
                      _vm._v("Practice Management & Software Solutions")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "library__collection library__collection--vendors"
                      },
                      [
                        _vm.loaders.vendors
                          ? _c(
                              "div",
                              { staticClass: "loading-indicator" },
                              [
                                _c("MoonLoader", {
                                  attrs: { size: "75px", color: "#ffffff" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.practiceManagementVendors, function(
                          vendor,
                          index
                        ) {
                          return _c("VendorCard", {
                            key: "pm-software-vendor-" + index,
                            attrs: { vendor: vendor }
                          })
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "library__group-header" }, [
                      _vm._v("Finance & Merchant Solutions")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "library__collection library__collection--vendors"
                      },
                      [
                        _vm.loaders.vendors
                          ? _c(
                              "div",
                              { staticClass: "loading-indicator" },
                              [
                                _c("MoonLoader", {
                                  attrs: { size: "75px", color: "#ffffff" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.financeVendors, function(vendor, index) {
                          return _c("VendorCard", {
                            key: "finance-vendor-" + index,
                            attrs: { vendor: vendor }
                          })
                        })
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "library__group-header" }, [
                      _vm._v("Other Vendors")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "library__collection library__collection--vendors"
                      },
                      [
                        _vm.loaders.vendors
                          ? _c(
                              "div",
                              { staticClass: "loading-indicator" },
                              [
                                _c("MoonLoader", {
                                  attrs: { size: "75px", color: "#ffffff" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.otherVendors, function(vendor, index) {
                          return _c("VendorCard", {
                            key: "other-vendor-" + index,
                            attrs: { vendor: vendor }
                          })
                        })
                      ],
                      2
                    )
                  ]
                : [
                    _c("div", { staticClass: "library__group-header" }, [
                      _vm._v("Vendor Partners")
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "library__collection library__collection--vendors"
                      },
                      [
                        _vm.loaders.vendors
                          ? _c(
                              "div",
                              { staticClass: "loading-indicator" },
                              [
                                _c("MoonLoader", {
                                  attrs: { size: "75px", color: "#ffffff" }
                                })
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.otherVendors, function(vendor, index) {
                          return _c("VendorCard", {
                            key: "vendor-" + index,
                            attrs: { vendor: vendor }
                          })
                        })
                      ],
                      2
                    )
                  ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c("VendorModal", { attrs: { "modal-key": "vendorModal" } }),
      _vm._v(" "),
      _c("FeaturedVendorModal", {
        attrs: { "modal-key": "featuredVendorModal" }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }